import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import acessoIcon from "../../assets/icons/perfil.png";

import AcessosRegrasService from "../../services/AcessosRegrasService";

export default function AcessosRegrasForm({
  itemSelecionado,
  modo,
  onClose,
}) {
  const [form, setForm] = useState({
    idRegra: null,
    idAcesso: null,
    nome: "",
    tabela: "",
    criar: false,
    atualizar: false,
    deletar: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
    const { setRetorno } = useGerenciamento();
  const [submitState, setSubmitState] = useState("IDLE"); 

  // ==========================
  // LOAD MODO
  // ==========================
  useEffect(() => {
    if (modo === "novo") {
      setForm({
        idRegra: null,
        idAcesso: itemSelecionado?.idAcesso || null,
        nome: "",
        tabela: "",
        criar: false,
        atualizar: false,
        deletar: false,
      });
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idRegra: itemSelecionado.idRegra,
        idAcesso: itemSelecionado.idAcesso,
        nome: itemSelecionado.nome || "",
        tabela: itemSelecionado.tabela || "",
        criar: !!itemSelecionado.criar,
        atualizar: !!itemSelecionado.atualizar,
        deletar: !!itemSelecionado.deletar,
      });
    }
  }, [modo, itemSelecionado]);

  // ==========================
  // HANDLERS
  // ==========================
  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  }

  // ==========================
  // VALIDATION
  // ==========================
  function validarCampos() {
    const e = {};

    if (!form.nome) e.nome = "Informe o nome";
    if (!form.tabela) e.tabela = "Informe a tabela";

    return e;
  }

  // ==========================
  // SUBMIT
  // ==========================
  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length) return;

    setLoading(true);

    try {
      if (modo === "novo") {
        const payload_create = { ...form };

        await AcessosRegrasService.create(payload_create);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Regra de acesso criado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      if (modo === "alterar") {
        const payload_update = { ...form };

        await AcessosRegrasService.update(form.idRegra, payload_update);

        setRetorno({
          tipo: "sucesso",
          mensagem: "Regra de acesso atualizado com sucesso!",
        });
        setSubmitState("SUCCESS");
      }

      onClose();
    } catch (error) {
        setRetorno({
          tipo: "erro",
          mensagem:
            modo === "novo"
              ? "Erro ao criar Regra de acesso."
              : "Erro ao atualizar Regra de acesso.",
        });

        setSubmitState("ERROR");
    } finally {
      setLoading(false);
    }
  }

  // ==========================
  // RENDER
  // ==========================
  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>
        <div className="Form-Interno-title">
          <img src={acessoIcon} alt="regras de acesso" className="icon" />
          {modo === "novo" ? "Cadastro de regras de acesso" : "Alterar regra de acesso"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Nome: *</div>
          <input name="nome" value={form.nome} onChange={handleChange} />
          {errors.nome && <span style={{ color: "red" }}>{errors.nome}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Tabela: *</div>
          <input name="tabela" value={form.tabela} onChange={handleChange} />
          {errors.tabela && <span style={{ color: "red" }}>{errors.tabela}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Criar</div>
          <select
            name="criar"
            value={String(form.criar)}
            onChange={handleChange}
          >
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div> 

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Atualizar</div>
          <select
            name="atualizar"
            value={String(form.atualizar)}
            onChange={handleChange}
          >
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div> 

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Deletar</div>
          <select
            name="deletar"
            value={String(form.deletar)}
            onChange={handleChange}
          >
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </select>
        </div> 

        <div className="Form-Interno-alinhamento-button">
          <button type="button"
            className="Form-Interno-alinhamento-button-inativo" onClick={onClose} >
              Inativo
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>
      </form>
    </div>
  );
}
